import { owaComputedFn } from 'owa-computed-fn';
import { getSelectedTableView } from 'owa-mail-list-store';
import { getFolderTable } from 'owa-folders';
import { STICKY_NOTE_FOLDER_CLASS } from 'owa-folders-constants';

/**
 * Returns true when the currently selected folder is a notes (sticky note) folder, e.g. the
 * primary distinguished notes folder or a non-default notes folder synced for an archive mailbox.
 * Mail item actions (reply, forward, delete, etc.) are not supported for notes folders, so this
 * is used to disable those ribbon buttons.
 */
export const isNotesFolderSelected: () => boolean = owaComputedFn(
    function isNotesFolderSelected(): boolean {
        const folderId = getSelectedTableView()?.tableQuery?.folderId;
        if (!folderId) {
            return false;
        }
        return getFolderTable().get(folderId)?.FolderClass === STICKY_NOTE_FOLDER_CLASS;
    }
);
